import Vue from 'vue'
import Router from 'vue-router'
// ... your routes

const router = new Router({
  // your router config
})

export default router


// WEBPACK FOOTER //
// ./src/router.js